<template>
    <v-app>
        <v-data-table :headers="headers" :items="supplierstocksblockeditems" :footer-props="{
            showFirstLastPage: true,
            showCurrentPage: true,
            itemsPerPageOptions: [50, 100, 150, -1],
            itemsPerPageAllText: 'Alle',
            itemsPerPageText: 'Datensätze pro Seite',
            pageText: '{0}-{1} von {2}'
        }">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Blockierte Lieferantenbestände</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="success" class="mx-2" fab dark small v-bind="attrs" v-on="on">
                                <v-icon dark>
                                    mdi-plus
                                </v-icon>
                            </v-btn>
                        </template>
                        <v-card>
                            <v-app-bar dark color="success">
                                <v-card-title>
                                    <span class="text-h5">{{ formTitle }}</span>
                                </v-card-title>
                            </v-app-bar>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-autocomplete v-model="editedItem.supplier_id" :items="suppliers"
                                                label="Lieferant*" item-text="supplierName" item-value="id"
                                                :rules="[rules.required]" required>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field label="ARAINR*" v-model="editedItem.ARAINR" type="number"
                                                hide-details="auto" :rules="[rules.required, 
                                                rules.counter]" required>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field label="Beschreibung" v-model="editedItem.description"
                                                hide-details="auto"></v-text-field>
                                        </v-col>
                                        <!-- <v-col cols="12">
                                            <v-switch v-model="editedItem.lastAction"
                                                :label="`Blockierung ${editedItem.lastAction > 0 ? 'aktiviert' : 'deaktiviert'}`"
                                                color="red" :false-value=0 :true-value=1></v-switch>
                                        </v-col> -->
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="error" text @click="close">
                                    Abbrechen
                                </v-btn>
                                <v-btn color="primary" @click="save"
                                    v-if="editedItem.supplier_id > 0 && editedItem.ARAINR > 0">
                                    Speichern
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete" max-width="800px">
                        <v-card>
                            <v-card-title class="text-h5 color-red">Sind Sie sicher, dass Sie diesen blockierten Artikel löschen
                                möchten?</v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="closeDelete">Abbrechen</v-btn>
                                <v-btn color="blue darken-1" text @click="deleteItemConfirm">Ja</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.supplier_id="{ item }">
                {{ item.supplier.supplierName }}
            </template>
            <!-- <template v-slot:item.lastAction="{ item }">
                <v-switch v-model="item.lastAction" color="red" disabled label=""></v-switch>
            </template> -->
            <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon class="mr-2" color="blue" v-bind="attrs" v-on="on" @click="editItem(item)">
                            mdi-pencil
                        </v-icon>
                    </template>
                    <span>Bearbeiten</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" @click="deleteItem(item)" color="red">
                            mdi-delete
                        </v-icon>
                    </template>
                    <span>Löschen</span>
                </v-tooltip>
            </template>
        </v-data-table>
    </v-app>
</template>
<script>
export default {
    props: {
        value: Array,
        url: {
            type: String,
            default: '/admin/supplierstocksblocked'
        },
        callback: {
            type: Function,
            default: () => ({})
        },
        catch: {
            type: Function,
            default: () => ({})
        },
        finally: {
            type: Function,
            default: () => ({})
        },
    },

    data: () => ({
        messagedialog: false,
        dialog: false,
        dialogDelete: false,
        rules: {
            required: value => !!value || 'Pflichtfeld.',
            counter: value => value.length > 14 || 'Mindestens 15 Ziffern',
        },
        headers: [
            {
                text: 'Id',
                align: 'start',
                sortable: true,
                value: 'id',
            },
            { text: 'Lieferant', value: 'supplier_id' },
            { text: 'ARAINR', value: 'ARAINR' },
            { text: 'Beschreibung', value: 'description' },
            { text: 'Erstellt am', value: 'created_at' },
            // { text: 'Status', value: 'lastAction' },
            { text: 'Aktionen', value: 'actions', sortable: false },
        ],
        success: false,
        suppliers: [],
        supplierstocksblockeditems: [],
        editedItem: {
            id: 0,
            supplierstocktemplate_id: 0,
            ARAINR: "",
            description: null,
            lastAction: 1,
        },
        defaultItem: {
            id: 0,
            supplierstocktemplate_id: 0,
            ARAINR: "",
            description: null,
            lastAction: 1,
        },
        boxOne: '',
    }),

    computed: {
        formTitle() {
            return this.editedItem.id === 0 ? 'Blockierung hinzufügen' : 'Blockierung bearbeiten'
        },
    },

    watch: {
        dialog(val) {
            val || this.close()
        },
        dialogDelete(val) {
            val || this.closeDelete()
        },
    },

    created() {
        this.getSuppliers();
        this.getSupplierStocksBlockedItems();
    },

    methods: {
        async getSuppliers() {
            axios.get('/admin/getsuppliers')
                .then(function (response) {
                    this.suppliers = response.data;
                }.bind(this));
        },

        async getSupplierStocksBlockedItems()
        {  
            axios.get('/admin/getblockedsupplierstocks')
                .then(function (response) {
                    this.supplierstocksblockeditems = response.data;
                }.bind(this));

        },
        editItem(item) {
            axios.get(this.url + '/' + item.id + '/edit')
                .then(function (response) {
                    this.editedItem = response.data;
                    this.dialog = true
                }.bind(this));
        },

        deleteItem(item) {
            axios.get(this.url + '/' + item.id + '/edit')
                .then(function (response) {
                    this.editedItem = response.data;
                    this.dialogDelete = true
                }.bind(this));
        },

        deleteItemConfirm() {
            axios.delete(this.url + '/' + this.editedItem.id)
                .then(response => {
                    this.showMsgBoxOne(response, true);
                }).catch(response => {
                    _this.catch(response);
                }).finally(response => {
                    _this.finally(response);
                });
            this.closeDelete()
        },

        close() {
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = this.defaultItem;
            })
        },

        closeDelete() {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = this.defaultItem;
            })
        },

        save() {
            const _this = this;
            if (this.editedItem.id > 0) {
                axios.put(this.url + '/' + this.editedItem.id,
                    this.editedItem,
                ).then(response => {
                    _this.callback(response);
                    this.showMsgBoxOne(response, true);
                }).catch(response => {
                    _this.catch(response);
                }).finally(response => {
                    _this.finally(response);
                });
            } else {
                axios.post(this.url,
                    this.editedItem,
                ).then(response => {
                    _this.callback(response);
                    this.showMsgBoxOne(response, true);
                }).catch(response => {
                    _this.catch(response);
                }).finally(response => {
                    _this.finally(response);
                });
            }
            // Hide the modal manually
            // this.$nextTick(() => {
            //     this.resetModal();
            //     this.$bvModal.hide('modal-prevent-closing')
            // })
            this.close()
        },

        showMsgBoxOne(callback, change) {
            this.$bvModal.msgBoxOk(callback.data)
                .then(value => {
                    if (change) {
                        this.$nextTick(() => {
                            this.editedItem = this.defaultItem;
                        });
                        this.getSupplierStocksBlockedItems();
                    }
                })
                .catch(err => {
                })
        },
    },
}
</script>